import React from 'react';
import clsx from 'clsx';
import { DialogTitle } from '@mui/material';
import { Icons, IconButton, Box } from "@curves/ui-base";

const GradientColorHeader = (props) => {
    const { title: propsTitle = '請設定標題', onClose: onCloseProps, children } = props;

    const handleOnClose = (e) => {
        onCloseProps && onCloseProps(e);
    };
    return (
        <DialogTitle className="dialog-title-header-primary text-center">
            <Box className={clsx('h5 text-gray-50 font-weight-bold', onCloseProps && 'dialog-title-margin')}>{children || propsTitle}</Box>
            {onCloseProps && (
                <Box className="dialog-title-header-close-icon">
                    <IconButton size="large" onClick={handleOnClose}>
                        <Icons.Close htmlColor="#fff" />
                    </IconButton>
                </Box>
            )}
        </DialogTitle>
    );
};

export default GradientColorHeader;
